export function getJwtToken() {
  const token = localStorage.getItem('token') ? localStorage.getItem('token') : sessionStorage.getItem('token');

  return token;
}

export function clearSession() {
  sessionStorage.clear();
}

export function setJwtToken(token) {
  sessionStorage.setItem('token', token);
}

// Utility function to store data in session storage
export function storeInSessionStorage(key, data) {
  // Retrieve the existing object from session storage
  const existingData = sessionStorage.getItem(key);

  // Parse the JSON string into a JavaScript object if it exists, otherwise initialize it
  let storageObject = existingData ? JSON.parse(existingData) : {};

  // Merge the new data into the existing object
  storageObject = { ...storageObject, ...data };

  // Convert the updated object back into a JSON string
  const updatedDataString = JSON.stringify(storageObject);

  // Store the updated JSON string back into session storage
  sessionStorage.setItem(key, updatedDataString);
}

// Utility function to retrieve data from session storage
export function retrieveFromSessionStorage(key) {
  // Retrieve the data from session storage
  const data = sessionStorage.getItem(key);

  // Parse the JSON string into a JavaScript object if it exists, otherwise return null
  return data ? JSON.parse(data) : null;
}

// Function to add/update key-value pairs in session storage
export function updateSessionStorage(newData, storageKey) {
  // Retrieve the existing object from session storage
  const existingData = sessionStorage.getItem(storageKey);

  // Parse the JSON string into a JavaScript object
  let productDetails = existingData ? JSON.parse(existingData) : { masterDetails: {} };

  // Update the object with new key-value pairs
  Object.keys(newData).forEach((key) => {
    productDetails[key] = newData[key];
  });

  // Convert the updated object back into a JSON string
  const updatedDataString = JSON.stringify(productDetails);

  // Store the updated JSON string back into session storage
  sessionStorage.setItem(storageKey, updatedDataString);
}
